import {
  LoadingButton as MuiLoadingButton,
  LoadingButtonProps as MuiLoadingButtonProps,
} from "@mui/lab";
import { styled } from "@mui/material";

import { brandColors } from "../../utils/brand-colors";

const StyledLoadingButton = styled(MuiLoadingButton)(({ theme }) => {
  return {
    backgroundColor:
      theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
    color: theme.palette.mode === "light" ? brandColors.ceasefireWhite : "#0b1b37",
    borderRadius: "6.25rem",
    textTransform: "none",
    padding: "0.25rem 1.25rem",
    width: "fit-content",

    "&.Mui-disabled:not(.MuiLoadingButton-loading)": {
      backgroundColor:
        theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
      color: "#7f8794",
    },

    "&:hover": {
      backgroundColor:
        theme.palette.mode === "light"
          ? brandColors.primaryButtonHoverLight
          : brandColors.primaryButtonHoverDark,
    },

    "&.MuiButton-contained&.MuiLoadingButton-loading": {
      color: "#7f8794",
      backgroundColor:
        theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
    },

    "&.MuiButton-outlined": {
      backgroundColor:
        theme.palette.mode === "light" ? brandColors.ceasefireWhite : brandColors.pirateBlack,
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
    "&.MuiButton-outlined&.MuiLoadingButton-loading": {
      color: "#7f8794",
    },

    // Style the loading indicator
    "& .MuiLoadingButton-loadingIndicator": {
      color: theme.palette.mode === "light" ? brandColors.ceasefireWhite : "#0b1b37",
    },
    "&.MuiButton-outlined .MuiLoadingButton-loadingIndicator": {
      color: "#7f8794",
    },
    "&.MuiButton-contained .MuiLoadingButton-loadingIndicator": {
      color: "#7f8794",
    },
  };
});

interface LoadingButtonProps extends MuiLoadingButtonProps {
  children: React.ReactNode;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({ children, ...props }) => {
  return <StyledLoadingButton {...props}>{children}</StyledLoadingButton>;
};

export default LoadingButton;
